import { ElMessageBox } from 'element-plus'

// Shared confirm dialog (same look as Call archive/restore).
// true if the user confirms, false if they cancel.
export async function confirmAction(message, title = 'Warning') {
  try {
    await ElMessageBox.confirm(message, title, {
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      type: 'warning',
    })
    return true
  } catch {
    return false
  }
}

// api.request resolves with { ok: false } on HTTP errors instead of throwing.
// This throws so callers can handle failure with a normal try/catch.
export function assertOk(data, fallbackMessage = 'Request failed') {
  if (!data?.ok) {
    throw new Error(data?.message || fallbackMessage)
  }
  return data
}
